import React from 'react';

/**
 * <ProgressBar value={72} label="Scanning DNS..." tone="accent" showPercent />
 */
const TONE = {
  accent: 'var(--accent)',
  cyan:   'var(--cyan)',
  success:'var(--success)',
  warning:'var(--warning)',
  danger: 'var(--danger)',
};

export default function ProgressBar({
  value = 0,
  label,
  tone = 'accent',
  size = 'md',
  showPercent = true,
  indeterminate = false,
  style,
  ...rest
}) {
  const color = TONE[tone] || tone;
  const height = size === 'sm' ? 4 : size === 'lg' ? 8 : 6;
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...style }} {...rest}>
      <div
        role="progressbar"
        aria-valuenow={indeterminate ? undefined : clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{
          height,
          background: 'var(--bg-elevated)',
          borderRadius: 'var(--radius-xs)',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            height: '100%',
            width: indeterminate ? '40%' : `${clamped}%`,
            background: color,
            borderRadius: 'var(--radius-xs)',
            transition: 'width var(--dur-slow) var(--ease-out)',
            boxShadow: `0 0 12px color-mix(in srgb, ${color} 30%, transparent)`,
            ...(indeterminate ? {
              animation: 'progress-indeterminate 1.4s var(--ease-in-out) infinite',
            } : {}),
          }}
        />
      </div>
      {(label || showPercent) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {label && (
            <span style={{
              fontSize: 'var(--fs-xs)', color: 'var(--text-secondary)',
              fontFamily: 'var(--font-mono)',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {label}
            </span>
          )}
          {showPercent && !indeterminate && (
            <span style={{
              fontSize: 'var(--fs-xs)', fontWeight: 'var(--fw-bold)',
              color, fontFamily: 'var(--font-mono)',
            }}>
              {clamped}%
            </span>
          )}
        </div>
      )}
    </div>
  );
}
